import api from './api';

class PackagesService {
  // Get all packages with filters and pagination
  async getPackages(params = {}) {
    try {
      const response = await api.get('/packages', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get package by ID
  async getPackage(id) {
    try {
      const response = await api.get(`/packages/${id}`);
      return response.data.package;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Create new package
  async createPackage(data) {
    try {
      const response = await api.post('/packages', data);
      return response.data.package;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Update package
  async updatePackage(id, data) {
    try {
      const response = await api.put(`/packages/${id}`, data);
      return response.data.package;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Delete package
  async deletePackage(id) {
    try {
      const response = await api.delete(`/packages/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get package images
  async getPackageImages(packageId) {
    try {
      const response = await api.get(`/packages/${packageId}/images`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Upload package images
  async uploadImages(packageId, files) {
    try {
      const formData = new FormData();
      files.forEach((file, index) => {
        formData.append('images', file);
      });

      const response = await api.post(`/packages/${packageId}/images`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Delete package image
  async deleteImage(packageId, imageId) {
    try {
      const response = await api.delete(`/packages/${packageId}/images/${imageId}`);
      return response.data;
    } catch (error) {
      throw error
    }
  }

  // Bulk operations
  async bulkUpdatePackages(data) {
    try {
      const response = await api.post('/packages/bulk', data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Toggle package status (active/inactive)
  async toggleStatus(id) {
    try {
      const response = await api.put(`/packages/${id}/toggle`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get package categories
  async getCategories() {
    try {
      const response = await api.get('/categories');
      return response.data.data.categories || [];
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Handle API errors
  handleError(error) {
    if (error.response?.data?.message) {
      console.log('masuk 1')
      return new Error(error.response.data.message);
    } else if(error.response?.data?.error.message) {
      return new Error(error.response?.data?.error.message);
    } else if (error.message) {
      console.log('masuk 3')
      return new Error(error.message);
    } else {
      console.log('masuk 4')
      return error;
    }
  }
}

export default new PackagesService();